<template>
  <div>
    <multiple_form
      :forms="forms"
      :edit="props.isEdit"
      :editData="props.editData"
      @submit="handelSubmit"
      v-if="!props.isViewRoute"
    >
      <map_line v-model="locationList"></map_line>
    </multiple_form>
    <map_line
      v-model="locationList"
      v-else
      :isView="props.isViewRoute"
    ></map_line>
  </div>
</template>
<script setup>
  import { defineProps, defineEmits, computed, ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { createData, updateData } from '@/api/car_route'
  import multiple_form from '@/components/multiple_form'
  import map_line from '@/components/map/map_line'
  //初始化
  const props = defineProps({
    isEdit: Boolean,
    isViewRoute: Boolean,
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      id: 'car_person',
      itemWidth: '420px',
      formItem: [
        {
          type: 'input',
          field: 'name',
          label: '路线名称',
        },
      ],
    },
  ])

  //路径点位数据
  const locationList = ref(
    props.editData?.route && JSON.parse(props.editData?.route)
  )
  // const locationList = ref()

  async function handelSubmit(data) {
    const ajaxFn = props.isEdit ? updateData : createData
    const messageText = props.isEdit ? '编辑' : '创建'
    const id = props.isEdit
      ? { [props.idField]: props.editData[props.idField] }
      : {}

    const res = await ajaxFn({
      ...data,
      ...id,
      route: JSON.stringify(locationList.value),
    })
    if (res.success) {
      message.success(messageText + '成功！')
      emit('submit')
    } else {
      message.warn(messageText + '错误：', res.message)
    }
  }
</script>
